module.exports = __webpack_public_path__ + "img/A7404364.4fba67fc.jpg";